/* product.js — variant selection, gallery, related products */
(function () {
  'use strict';
  const theme = window.theme || {};

  const root = document.querySelector('[data-product-root]');
  if (root) initProduct(root);

  function initProduct(container) {
    const jsonEl = container.querySelector('[data-product-json]');
    const product = jsonEl ? JSON.parse(jsonEl.textContent) : null;

    const form = container.querySelector('[data-product-form]');
    const idInput = container.querySelector('[data-variant-id]');
    const buyNow = container.querySelector('[data-buy-now]');
    const qtyInput = form ? form.querySelector('input[name="quantity"]') : null;

    function syncBuyNow(variant) {
      if (!buyNow) return;
      const qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      const available = variant ? variant.available : !buyNow.classList.contains('is-disabled');
      if (variant) buyNow.href = `/cart/${variant.id}:${qty}`;
      else buyNow.href = buyNow.href.replace(/:\d+$/, `:${qty}`);
      buyNow.classList.toggle('is-disabled', !available);
      if (available) {
        buyNow.removeAttribute('aria-disabled');
        buyNow.removeAttribute('tabindex');
      } else {
        buyNow.setAttribute('aria-disabled', 'true');
        buyNow.setAttribute('tabindex', '-1');
      }
    }
    if (qtyInput) qtyInput.addEventListener('change', () => syncBuyNow(null));
    const priceCurrent = container.querySelector('[data-price-current]');
    const priceWas = container.querySelector('[data-price-was]');
    const offBadge = container.querySelector('[data-off-badge]');
    const priceWrap = container.querySelector('[data-price]');
    const atc = container.querySelector('[data-atc]');
    const galleryMain = container.querySelector('[data-gallery-main]');
    const thumbs = Array.from(container.querySelectorAll('[data-gallery-thumb]'));
    const s = theme.strings || {};

    /* ---------- Gallery ---------- */
    function activateThumb(btn) {
      thumbs.forEach((t) => t.classList.toggle('is-active', t === btn));
      if (galleryMain && btn) galleryMain.src = btn.getAttribute('data-src');
    }
    thumbs.forEach((btn) => btn.addEventListener('click', () => activateThumb(btn)));

    /* ---------- Color → media map (color-level switching) ---------- */
    let colorMediaMap = {};
    const mapEl = container.querySelector('[data-color-media-map]');
    if (mapEl) {
      try { colorMediaMap = JSON.parse(mapEl.textContent) || {}; } catch (e) { colorMediaMap = {}; }
    }
    const colorGroup = container.querySelector('[data-option-group][data-color-option]');

    function switchToMediaId(mediaId) {
      if (!mediaId) return false;
      const btn = thumbs.find((t) => t.getAttribute('data-media-id') === String(mediaId));
      if (btn) { activateThumb(btn); return true; }
      return false;
    }

    function switchToColor(colorValue) {
      if (colorValue == null) return false;
      let mid = colorMediaMap[colorValue];
      if (mid == null) {
        const key = Object.keys(colorMediaMap).find((k) => k.toLowerCase() === String(colorValue).toLowerCase());
        if (key) mid = colorMediaMap[key];
      }
      return switchToMediaId(mid);
    }

    /* ---------- Variant selection (chips preferred, selects as fallback) ---------- */
    function selectedOptions() {
      const groups = Array.from(container.querySelectorAll('[data-option-group]'))
        .sort((a, b) => a.dataset.optionIndex - b.dataset.optionIndex);
      if (groups.length) {
        return groups.map((g) => {
          const active = g.querySelector('[data-option-chip].is-active');
          return active ? active.dataset.value : null;
        });
      }
      return Array.from(container.querySelectorAll('[data-option-select]'))
        .sort((a, b) => a.dataset.optionIndex - b.dataset.optionIndex)
        .map((sel) => sel.value);
    }

    function findVariant(options) {
      if (!product) return null;
      return product.variants.find((v) => options.every((opt, i) => v[`option${i + 1}`] === opt));
    }

    function updateVariant() {
      const variant = findVariant(selectedOptions());

      if (!variant) {
        if (atc) {
          atc.disabled = true;
          atc.textContent = s.unavailable || 'Unavailable';
        }
        return;
      }

      if (idInput) idInput.value = variant.id;

      const fm = theme.formatMoney || ((c) => (c / 100).toFixed(2));
      if (priceCurrent) priceCurrent.textContent = fm(variant.price);
      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (priceWas) {
        priceWas.hidden = !onSale;
        if (onSale) priceWas.textContent = fm(variant.compare_at_price);
      }
      if (offBadge) {
        offBadge.hidden = !onSale;
        if (onSale) {
          const pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
          offBadge.textContent = `${pct}% OFF`;
        }
      }
      if (priceWrap) priceWrap.classList.toggle('price--on-sale', Boolean(onSale));

      if (atc) {
        atc.disabled = !variant.available;
        atc.textContent = variant.available ? s.addToCart || 'Add to cart' : s.soldOut || 'Sold out';
      }

      const stockEl = container.querySelector('[data-stock-status]');
      if (stockEl) {
        stockEl.textContent = variant.available ? 'In Stock' : 'Out of Stock';
        stockEl.classList.toggle('product-info__stock--out', !variant.available);
      }

      let switched = false;
      if (colorGroup) {
        const active = colorGroup.querySelector('[data-option-chip].is-active');
        if (active) switched = switchToColor(active.dataset.value);
      }
      if (!switched && variant.featured_media && variant.featured_media.id) {
        switchToMediaId(variant.featured_media.id);
      }

      syncBuyNow(variant);

      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {
        /* noop */
      }
    }

    container.querySelectorAll('[data-option-select]').forEach((sel) => sel.addEventListener('change', updateVariant));

    container.querySelectorAll('[data-option-group]').forEach((group) => {
      group.addEventListener('click', (e) => {
        const chip = e.target.closest('[data-option-chip]');
        if (!chip) return;
        group.querySelectorAll('[data-option-chip]').forEach((c) => {
          c.classList.toggle('is-active', c === chip);
          c.setAttribute('aria-checked', String(c === chip));
        });
        updateVariant();
      });
    });
  }

  /* ---------- Related products (Product Recommendations API) ---------- */
  const related = document.querySelector('[data-related]');
  if (related) {
    const url = related.getAttribute('data-url');
    if (url && !related.querySelector('.grid')) {
      fetch(url)
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('[data-related]');
          if (fresh && fresh.querySelector('.grid')) related.replaceWith(fresh);
        })
        .catch(() => {});
    }
  }
})();
